import { OrderDirection, TableHeader } from '@beego/ngx-table';
import { translate } from '@shared-libs/helpers';

export class TypeTableFactory {
	public static getHeaders(): Array<TableHeader> {
		return [
			new TableHeader(translate('DEVICE_TYPE.NAME'), ['name', OrderDirection.asc], 4),
			new TableHeader(translate('DEVICE_TYPE.DESCRIPTION'), null, 10),
			new TableHeader(),
		];
	}
}
